export const formatCommissions = ({ coldCustomer, newCustomer, restOfSite }) => {
    return { coldCustomer: coldCustomer || 0, newCustomer: newCustomer || 0, restOfSite: restOfSite || 0 };
};
